import ChallengeTypeText from './ChallengeTypeText';

export default ChallengeTypeText;
